import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import { Col, Row, Alert } from 'reactstrap';

// Local Deps
import './AddInventory.scss';
import AddInventoryForm from '../forms/AddInventoryForm';
import AddInventoryHOC from './AddInventoryHOC';

class AddInventory extends Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    formValues: PropTypes.object.isRequired,
    alertType: PropTypes.string.isRequired,
    alertMessage: PropTypes.string.isRequired,
    hideMessage: PropTypes.func.isRequired,
    handleInitalValueReset: PropTypes.func.isRequired,
    onReturnToMainPage: PropTypes.func.isRequired,
  };

  static initialState = {};

  state = AddInventory.initialState;

  render() {
    const {
      onSubmit,
      alertType,
      alertMessage,
      formValues,
      hideMessage,
      handleInitalValueReset,
      onReturnToMainPage
    } = this.props;

    return (
      <div className="nf-add-tool">
        <Helmet>
          <meta charSet="utf-8" />
          <title>NFFS ICON - Add Inventory Page</title>
        </Helmet>
        <Row id='addToolingContainer'>
          <Col>
            <Row
              style={{
                display: 'flex',
                justifyContent: 'space-around',
              }}
            >
              <Alert color="light" style={{ fontSize: '.75rem' }} />
            </Row>
            <Row
              style={{
                display: 'flex',
                justifyContent: 'space-around',
              }}
            >
              {alertMessage && (
                <Alert color={alertType} toggle={hideMessage}>
                  {alertMessage}
                </Alert>
              )}
            </Row>

            {/* <!-- FORM --> */}

            <Row>
              <div className="nf-add-tool__form">
                <AddInventoryForm
                  onSubmit={onSubmit}
                  initialValues={formValues}
                  handleInitalValueReset={handleInitalValueReset}
                  onReturnToMainPage={onReturnToMainPage}
                />
              </div>
            </Row>


          </Col>
        </Row>
      </div>
    );
  }
}

export default AddInventoryHOC(AddInventory);



// WEBPACK FOOTER //
// ./src/components/AddInventory/AddInventory.jsx